import Felipe from "Assets/Common/felipe.png";
import Brasas from "Assets/Common/foto-as-brasas.jpeg";
import Cock from "Assets/Common/foto-cock-briga-de-galo.jpeg";
import Dogville from "Assets/Common/foto-dogville.jpeg";
import Ficcoes from "Assets/Common/foto-ficcoes.jpeg";
import Caso from "Assets/Common/foto-fim-de-caso.jpeg";
import Kafka from "Assets/Common/kafka.jpg";
import Logo from "Assets/Common/logo.png";

import * as S from "./styles";

import "swiper/css";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const About = () => {
  const mainImages = [
    {
      id: 1,
      src: Brasas,
      alt: "As Brasas",
    },
    {
      id: 2,
      src: Cock,
      alt: "Cock - Briga de Galo",
    },
    {
      id: 3,
      src: Dogville,
      alt: "Dogville",
    },
    {
      id: 4,
      src: Ficcoes,
      alt: "Ficções",
    },
    {
      id: 5,
      src: Caso,
      alt: "Fim de Caso",
    },
    {
      id: 6,
      src: Kafka,
      alt: "Kafka",
    },
  ];

  return (
    <S.Wrapper>
      <S.CarouselWrapper>
        <Swiper
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          loop={true}
          navigation={false}
          pagination={false}
          speed={700}
        >
          {mainImages.map((image, index) => (
            <SwiperSlide key={index}>
              <S.BannerImg src={image.src} alt={image.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </S.CarouselWrapper>
      <S.Container>
        <S.Description>
          Desde que iniciou suas atividades, através do espetáculo “R&J de
          Shakespeare”, a Sevenx Produções Artísticas vem se especializando na
          idealização de projetos culturais, esportivos e sociais, atuando
          também nas áreas de captação de recursos, consultoria, elaboração de
          projetos, gestão de recursos incentivados e intermediando a
          contratação de profissionais no mercado artístico.
        </S.Description>

        <S.Main>
          <S.Logo src={Logo} alt="Logo Sevenx" />

          <S.Felipe src={Felipe} alt="Felipe Heráclito Lima" />

          <S.Column>
            <h2>Felipe Heráclito Lima</h2>

            <p>
              Formado em Publicidade & Propaganda pela PUC-RJ e em Artes Cênicas
              pela CAL, Felipe Heráclito Lima é especialista em captação de
              recursos, em consultoria e gestão de recursos incentivados e em
              idealização e produção de projetos culturais.
            </p>
          </S.Column>
        </S.Main>
      </S.Container>
    </S.Wrapper>
  );
};

export default About;
